
import { RevBreadcrumb } from '@backmarket/design-system'

export default {
  components: {
    RevBreadcrumb,
  },
  props: {
    breads: {
      type: Array,
      required: true,
    },
  },
  computed: {
    links() {
      return this.breads.map(({ title, link }) => ({ title, slug: link }))
    },
  },
}
